import React from 'react';
import { Outlet, } from 'react-router-dom';
import { Layout, Col, Row } from 'antd';
import logo from "../assets/logowhite-new.png";
import PageHeader from '../components/pageHeader';
import Sidebar from '../components/sidebar';

const { Header, Content } = Layout;

const MainLayout = () => {

  return (
    <Layout>
        <Header>
          <Row align="middle">
            <Col>
              <img src={logo} style={{width: '100px'}} alt="RETISIO Logo" />
            </Col>
            <Col>
              <h1>Invoice System</h1>
            </Col>
          </Row>
        </Header>
        <Layout>
          <Sidebar />
          <Layout>
            <PageHeader />
            <Content
              style={{
                padding: 16,
                minHeight: 280,
              }}
            >
              <Outlet />
            </Content>
          </Layout>
        </Layout>
      </Layout>
  );
};

export default MainLayout;
